(function () {
  'use strict';

  var specificationHeadingPattern = /^(?:specifications?(?:\s+for\b.*)?|technical specifications?|technical details|technical information|sizing information|size chart|length and weight)\s*:?$/i;
  var descriptionHeadingPattern = /^descriptions?\s*:?$/i;
  var headingSelector = 'h1, h2, h3, h4, h5, h6';

  function stripImportedTypography(element) {
    [
      'font-family',
      'font-size',
      'font-weight',
      'font-style',
      'line-height',
      'letter-spacing',
      'text-transform',
      'color',
      'background-color'
    ].forEach(function (property) {
      element.style.removeProperty(property);
    });
    if (!element.getAttribute('style')) {
      element.removeAttribute('style');
    }
  }

  function removeSpecificationSection(heading) {
    var next = heading.nextElementSibling;
    while (next && !next.matches(headingSelector)) {
      var nestedHeading = next.querySelector(headingSelector);
      if (nestedHeading) {
        var branch = nestedHeading;
        while (branch && branch.parentElement !== next) {
          while (branch.previousSibling) {
            branch.previousSibling.remove();
          }
          branch = branch.parentElement;
        }
        if (branch) {
          while (branch.previousSibling) {
            branch.previousSibling.remove();
          }
        }
        break;
      }
      var current = next;
      next = next.nextElementSibling;
      current.remove();
    }
    heading.remove();
  }

  function flattenDetails(description, hasSeparateSpecifications) {
    description.querySelectorAll('details').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      var title = summary ? summary.textContent.trim() : '';

      if (hasSeparateSpecifications && specificationHeadingPattern.test(title)) {
        details.remove();
        return;
      }

      var fragment = document.createDocumentFragment();
      if (title && !descriptionHeadingPattern.test(title)) {
        var heading = document.createElement('h3');
        heading.textContent = title;
        fragment.appendChild(heading);
      }
      if (summary) {
        summary.remove();
      }
      while (details.firstChild) {
        fragment.appendChild(details.firstChild);
      }
      details.replaceWith(fragment);
    });
  }

  function removeEmbeddedTables(description) {
    description.querySelectorAll('table').forEach(function (table) {
      var previous = table.previousElementSibling;
      while (previous && !previous.textContent.trim()) {
        var emptyNode = previous;
        previous = previous.previousElementSibling;
        emptyNode.remove();
      }
      if (previous && previous.matches(headingSelector) && specificationHeadingPattern.test(previous.textContent.trim())) {
        previous.remove();
      }
      table.remove();
    });
  }

  function removeEmptyImportedNodes(description) {
    for (var pass = 0; pass < 3; pass += 1) {
      description.querySelectorAll(headingSelector + ', section, article, header, footer, div, p').forEach(function (node) {
        if (!node.textContent.trim() && !node.querySelector('img, video, iframe')) {
          node.remove();
        }
      });
    }
  }

  function cleanDescription(description) {
    if (description.dataset.descriptionCleaned === 'true') return;
    description.dataset.descriptionCleaned = 'true';

    var hasSeparateSpecifications = description.dataset.hasSeparateSpecifications === 'true';
    description.querySelectorAll('style, meta, script, o\\:p').forEach(function (node) {
      node.remove();
    });
    description.querySelectorAll('[style]').forEach(stripImportedTypography);
    description.querySelectorAll('google-sheets-html-origin').forEach(function (wrapper) {
      wrapper.replaceWith.apply(wrapper, Array.from(wrapper.childNodes));
    });

    flattenDetails(description, hasSeparateSpecifications);
    if (hasSeparateSpecifications) {
      removeEmbeddedTables(description);
      Array.from(description.querySelectorAll(headingSelector)).forEach(function (heading) {
        if (specificationHeadingPattern.test(heading.textContent.trim())) {
          removeSpecificationSection(heading);
        }
      });
    }
    removeEmptyImportedNodes(description);
  }

  function init() {
    document.querySelectorAll('.product-description--non-bike').forEach(cleanDescription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
